import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import {
  Typography,
  Stack,
  Card,
  CardContent,
  AvatarGroup,
  Avatar,
} from '@mui/material';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
import {
  JobPostStatusChip,
} from './';
// hooks
import useResponsive from '../../hooks/useResponsive';
// constants
import { POSITION_OPTION_DICT } from '../../constants';


JobPostCard.propTypes = {
  jobPost: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
};

export default function JobPostCard({ jobPost, onClick }) {
  const smUp = useResponsive('up', 'sm');
  const [matchingCandidates, setMatchingCandidates] = useState([{}, {}, {}]);
  const grayQuestionSrc = "https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/profile_empty.png";
  const avatarBlur = jobPost?.status === "stop";
  const avatarHidden = [
    'position-set', 'method-direct', 'method-paste', 'external-link-set', 'write-position', 'detail-position-set', 'context-set', 'monthly-budget-set', 'task-set',
    'review-requested', 'write-requested',
    'feedback-rewrite',
  ].includes(jobPost?.status);

  const MATCH_CAPACITY = Math.max(jobPost?.accept_capacity || 3, jobPost?.candidate_set?.length || 0);

  useEffect(() => {
    if (jobPost) {
      const candidates = Array(MATCH_CAPACITY).fill({});
      jobPost?.candidate_set?.slice(0, MATCH_CAPACITY).forEach((candidate, index) => {
        candidates[index] = candidate;
      });
      setMatchingCandidates(candidates);
    }
  }, [jobPost]);

  return (
    <Card
      onClick={onClick}
      variant="outlined"
      sx={{
        justifyContent: 'center',
        borderRadius: 1.5,
        border: 1,
        borderColor: "rgba(145, 158, 171, 0.24)",
        boxShadow: "none",
        bgcolor: "common.white",
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        minHeight: smUp ? 200 : 150,
        '&:hover': {
          cursor: 'pointer',
          bgcolor: "rgba(145, 158, 171, 0.08)",
        },
      }}
    >
      <CardContent sx={{ p: 3, '&:last-child': { p: 3 }, height: 1 }}>
        <Stack justifyContent={"space-between"} sx={{ height: '100%' }}>
          <Stack direction="row" alignItems={"flex-start"} spacing={1} justifyContent={"space-between"}>
            <Stack>
              <Typography variant="subtitle2" color={avatarBlur ? "text.secondary" : "text.primary"}>
                {POSITION_OPTION_DICT[jobPost.position]}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ opacity: jobPost?.detail_role?.role ? 1 : 0 }}>
                {jobPost?.detail_role?.card_display_name || jobPost?.detail_role?.role || '-'}
              </Typography>
            </Stack>
            <JobPostStatusChip status={jobPost.status} />
          </Stack>

          <Stack spacing={.5}>
            <Stack direction="row" alignItems="center" justifyContent={avatarHidden ? "flex-end" : "space-between"}>
              <AvatarGroup
                sx={{
                  visibility: avatarHidden ? "hidden" : "visible",
                  "& .MuiAvatarGroup-avatar:first-of-type": { backgroundColor: "transparent" },
                  "& .MuiAvatar-root": { border: "none" },
                }}
              >
                {matchingCandidates?.map((candidate, index) => (
                  <Avatar key={index}
                    src={candidate?.crew?.randomhash ? `https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${candidate.crew?.randomhash}.png` : grayQuestionSrc}
                    alt={`candidate-${index}`}
                    color={'default'}
                    sx={{
                      width: candidate?.id ? 28 : 32,
                      height: candidate?.id ? 28 : 32,
                      opacity: avatarBlur ? 0.5 : 1,
                      visibility: avatarHidden ? "hidden" : "visible",
                      ...candidate?.crew?.randomhash && { border: "2px solid #637381 !important" },
                    }}
                  />
                ))}
              </AvatarGroup>
              <SvgIconStyle src={"/icons/icon-arrow-right-android-mono.svg"} sx={{ width: 18, height: 18 }} />
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
